import img1 from '../assets/img/home/img1.jpg';

export default function AboutUs() {



    return(
        <div className='content'> 
        <h1>Quiénes somos</h1>
            <div className='flex_column'>
                <section className='flexSection'>
                    <div className='secition_text'>
                        <p>En especialistaenheridas.cl, conectamos a pacientes con enfermeras especialistas en curación avanzada de heridas que ofrecen atención profesional y personalizada a domicilio. Nuestro objetivo es garantizar que cada paciente reciba cuidados de calidad en un entorno seguro y cómodo, respaldados por profesionales altamente capacitados y verificados.</p>

                        <h2>Nuestra Misión</h2>
                        <p>Facilitar el acceso a atención especializada en curación de heridas a domicilio, promoviendo un estándar elevado en la calidad de los cuidados y una experiencia de salud centrada en las necesidades del paciente.</p>

                        <h2>Nuestra Visión</h2>
                        <p>Ser el referente nacional en atención domiciliaria especializada en curación de heridas, consolidando una red de profesionales confiables y reconocidos por su excelencia.</p>
                    </div>
                    <img src={img1} alt="nurse" className='section_img' />
                </section>


                <section>
                    

                    <h2>¿Por qué elegirnos?</h2>
                    <p><span className='highlight_text'>Pacientes:</span> Te conectamos con profesionales certificados y validados, asegurando que la atención que recibas sea segura, especializada y de calidad.</p>
                    <p><span className='highlight_text'>Enfermeras:</span> Te ofrecemos una plataforma exclusiva para destacar tu experiencia y conectar con pacientes en tu zona, respaldando tu práctica profesional con visibilidad y confianza.</p>
                    <p><span className='highlight_text'>Verificación rigurosa:</span>Cada perfil registrado pasa por un proceso de validación exhaustivo para garantizar que nuestras enfermeras cuentan con la formación y experiencia necesarias para brindar una atención de primer nivel.
                    </p>

                </section>

                <section>
                    <h2>¿Cómo funciona para los pacientes?</h2>
                    <p>A través de nuestra plataforma, puedes encontrar fácilmente enfermeras especializadas en tu zona:</p>
                    <ol> 
                        <li>Selecciona tu ubicación: Filtra por comuna o ciudad para acceder a enfermeras disponibles en tu área.</li>
                        <li>Elige la especialidad: Indica el tipo de atención que necesitas, como cuidado avanzado de heridas crónicas, postquirúrgicas o úlceras por presión.</li>
                        <li>Confirma la atención: Agenda una visita domiciliaria con la enfermera que mejor se ajuste a tus necesidades, respaldada por la validación de su perfil y credenciales.</li>
                    </ol>
                </section>

                <section>

                    <h2>¿Cómo funciona para las enfermeras?</h2>
                    <p>Únete a nuestra red y recibe pacientes en tu zona de manera sencilla, garantizando que tu experiencia profesional sea valorada:</p>
                    <ol>
                        <li>Crea tu perfil: Registra tus datos profesionales, sube tus certificados de especialización y detalla tu experiencia.</li>
                        <li>Espera la validación: Todos los perfiles son revisados por nuestro equipo para garantizar que cumplan con los estándares requeridos. Esto incluye la verificación de credenciales, experiencia y certificados.</li>
                        <li>Define tus servicios: Una vez aprobado tu perfil, detalla las áreas de atención que ofreces y las comunas donde trabajas.</li>
                        <li>Interactúa con pacientes: Utiliza nuestro sistema de contacto directo para gestionar consultas y agendar visitas.</li>
                    </ol>
                    
                </section>

                <section>
                <p>En <span className='highlight_text'>especialistaenheridas.cl</span>, nos esforzamos por ofrecer una plataforma segura y confiable tanto para pacientes como para enfermeras. Nos comprometemos a ser un puente que facilite la atención domiciliaria de calidad, respaldado por un riguroso proceso de verificación profesional. Con nosotros, recibir o brindar atención especializada está a solo un clic de distancia.</p>
                </section>

                
            </div>
        </div>
        
    )
}